// extracted by mini-css-extract-plugin
export default {"theme_switcher":"ThemeSwitcher_theme_switcher__lZoc+","winter":"ThemeSwitcher_winter__V5sAW","active":"ThemeSwitcher_active__O1GUy"};